
var bestFinanceRate = .0237; //which currently is 60 month financing via equipmoney

jQuery(document).ready(function() {

    // on equipmoney click
    jQuery(".equipmoneylink").click(function () {
        jQuery(".rate-area, .text-area, .loanamount").addClass('hidden');
        runRates();
        jQuery(".em-rate-area, .em-text, .loanamount").removeClass('hidden');
    });

    // on creditkey click
    jQuery(".creditkeylink").click(function () {
        jQuery(".rate-area, .text-area, .loanamount").addClass('hidden');
        runRates();
        jQuery(".ck-rate-area, .ck-text, .loanamount").removeClass('hidden');
    });

    // on shoppay click
    jQuery(".shoplink").click(function () {
        jQuery(".rate-area, .text-area, .loanamount").addClass('hidden');
        runRates();
        jQuery(".shop-rate-area, .shop-text, .loanamount").removeClass('hidden');
    });

    // on default text click
    jQuery(".defaultlink").click(function () {
        jQuery(".rate-area, .text-area, .loanamount").addClass('hidden');
        runRates();
        jQuery(".default-text").removeClass('hidden');
    });

    // on shop instruction text click
    jQuery("#shop-instruct").click(function () {
        jQuery(".rate-area, .text-area, .loanamount").addClass('hidden');
        runRates();
        jQuery(".shop-instructions").removeClass('hidden');
    });



    jQuery("#loan-amount").keyup(function(){
        runRates();
    });

    //EquipMoney Radio Clicks
    // jQuery(".em-radio").click(function () {
    //     runRates();
    // });
    jQuery("#em-terms").change(function () {
        runRates();
    });
    setTimeout(function(){
        jQuery("#spoof-addtocart").click(function () {
            jQuery(".product-form--atc-button").first().trigger('click').trigger('click');
            
            closePaymentPop('payment-request');
        });
    },1000);
});

function calculateFixedMonthlyPayment(loanAmount, apr, loanTerm) {
    // Convert APR to monthly interest rate
    var monthlyInterestRate = apr / 12;

    // Calculate the fixed monthly payment
    var fixedMonthlyPayment = (monthlyInterestRate * loanAmount) / (1 - Math.pow(1 + monthlyInterestRate, -loanTerm));

    return fixedMonthlyPayment;
}
function calculateTotalInterest(loanAmount, fixedMonthlyPayment, loanTerm) {
    // Calculate the total interest paid
    var totalInterest = (fixedMonthlyPayment * loanTerm) - loanAmount;

    return totalInterest;
}

function runRates(){
    var location = window.location.hostname;
    var loanAmount = jQuery("#loan-amount").val();
    loanAmount = loanAmount.replace('$','');
    loanAmount = parseFloat(loanAmount);

    if (loanAmount != 0 && !isNaN(loanAmount)) {

    //ShopPay
        var apr = 0.15;

        //3 month
        var fixedPayment3 = calculateFixedMonthlyPayment(loanAmount, apr, 3);
        var totalInterest3 = calculateTotalInterest(loanAmount, fixedPayment3.toFixed(2), 3);
        var totalpaid3 = totalInterest3 + loanAmount;
        jQuery(".3month .price-per-term span").text(fixedPayment3.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}));
        jQuery(".3month .interest-amount .interest-value span").text(totalInterest3.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}));
        jQuery(".3month .interest-total .interest-value span").text(totalpaid3.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}));
        //12 month
        var fixedPayment12 = calculateFixedMonthlyPayment(loanAmount, apr, 12);
        var totalInterest12 = calculateTotalInterest(loanAmount, fixedPayment12.toFixed(2), 12);
        var totalpaid12 = totalInterest12 + loanAmount;
        jQuery(".12month .price-per-term span").text(fixedPayment12.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}));
        jQuery(".12month .interest-amount .interest-value span").text(totalInterest12.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}));
        jQuery(".12month .interest-total .interest-value span").text(totalpaid12.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2}));

    //CreditKey
        // Payments = cost/payment*(1+rate) (not sure about this)
        // Payments = cost/12*1.01 (not sure about this)

        jQuery("#ck-rate span.rate").text((loanAmount/12*1.01).toFixed(2));

    //EquipMoney
        // For Select area
        jQuery("#em-bb-12-select-rate .rate").text((loanAmount * .0894).toFixed(2));
        jQuery("#em-bb-12-select").attr('ratedata',(loanAmount * .0894).toFixed(2));

        jQuery("#em-bb-24-select-rate .rate").text((loanAmount * .0487).toFixed(2));
        jQuery("#em-bb-24-select").attr('ratedata',(loanAmount * .0487).toFixed(2));

        jQuery("#em-bb-36-select-rate .rate").text((loanAmount * .0344).toFixed(2));
        jQuery("#em-bb-36-select").attr('ratedata',(loanAmount * .0344).toFixed(2));

        jQuery("#em-bb-48-select-rate .rate").text((loanAmount * .0276).toFixed(2));
        jQuery("#em-bb-48-select").attr('ratedata',(loanAmount * .0276).toFixed(2));
        //note, bestrate needs to be global for leasestation functionality that was repurposed
        jQuery("#em-bb-60-select-rate .rate").text((loanAmount * bestFinanceRate).toFixed(2));
        jQuery("#em-bb-60-select").attr('ratedata',(loanAmount * bestFinanceRate).toFixed(2));

        jQuery("#em-bd-13-select-rate .rate").text((loanAmount * .083333).toFixed(2));
        jQuery("#em-bd-13-select").attr('ratedata',(loanAmount * .083333).toFixed(2));

        //show selected rate area
        var rateTextId = "#"+jQuery('#em-terms').find(":selected").attr('id')+"-rate";
        jQuery('.em-select-text').hide();
        jQuery(rateTextId).show();
        //alert(rateTextId);



        if(location.includes('airmovers.com')){
            var apiKey = 'apikey=o25a9kfm5zf4i4y1kd7ka882ke4ehltenwluo8ng';
        }else if (location.includes('carpetextractors.com')){
            var apiKey = 'apikey=65p31omf440owjyds2fgfsrb1uia9f9mb8envbzk';
        }else if (location.includes('floorbuffers.com')){
            var apiKey = 'apikey=m4dgzg15ivnla1rzow7r7e9u0u5671ssijyjppln';
        }else if (location.includes('floorscrubbers.com')){
            var apiKey = 'apikey=y6of02tnrzd60t8a4yyzag0ckz7suttjioreyble';
        }else{
            var apiKey = 'apikey=7da8oxb72fq4n08k8gl43dlm4xrkg2ags8ofcyhl';
        }


        var eqUrl = 'https://www.leaseconsultants.com/Tools/BaseApplication/BaseApplication.php?';
        //var apiKey = 'apikey=7da8oxb72fq4n08k8gl43dlm4xrkg2ags8ofcyhl';
        var plan = '&plan=BestBuy'; //BestBuy

        if (jQuery('#em-terms').find(":selected").attr('id') == 'em-bd-13-select'){
            plan = '&plan=2'; //Baker's Dozen
        }
        var termsTerm = '&termsTerm='+ jQuery('#em-terms').find(":selected").attr('value');
        var cartTotal = '&cartTotal=' + loanAmount;
        var termsMonthly = '&termsMonthly='+jQuery('#em-terms').find(":selected").attr('ratedata');
        var itemsSKUs = '&itemsSKUs='+jQuery("#requestedskus").text();
        var itemCounts = '&itemCounts='+jQuery("#requestedqty").text();

        //jQuery("#em-appLinkTest").text(eqUrl+apiKey+plan+termsTerm+cartTotal+termsMonthly+itemsSKUs+itemCounts);
        jQuery("#em-appLink").attr("href",eqUrl+apiKey+plan+termsTerm+cartTotal+termsMonthly+itemsSKUs+itemCounts);
        jQuery("#em-appLink").removeClass('hidden');
    }
}


function getPaymentOptions(e,amount = 0, requestedsku, requestedqty, apptype='unset'){
    if(apptype == 'unset' || apptype == ''){
        apptype = 'default';
        
    }
    e.preventDefault();

    jQuery(".finance-pop-overlay").removeClass('hidden');
    jQuery(".rate-area, .text-area").addClass('hidden');
    jQuery(".loanamount").addClass('hidden');

    if (!jQuery('#acp-overlay').hasClass('ajaxcartpro-box-show')){
        jQuery('#acp-overlay').removeClass('ajaxcartpro-box-hide').addClass('ajaxcartpro-box-show');
    }
    var w = (jQuery(window).width() - 310) / 2,
        h = (jQuery(window).height() - 400) / 2;
    var paymentRequest = jQuery('#payment-request');
    jQuery(paymentRequest).css({'left':w+'px','top':h+'px'});

    jQuery(paymentRequest).removeClass('hidden');

    if (amount == 0){
        amount = 1000.00;
    }
    jQuery('#loan-amount').val('$'+ amount.toFixed(2));
    jQuery('#requestedskus').text(requestedsku);
    jQuery('#requestedqty').text(requestedqty);

    runRates();
    if(apptype == 'ck'){
        jQuery(".ck-rate-area, .ck-text").removeClass('hidden');
        jQuery(".loanamount").removeClass('hidden');
    }else if(apptype == 'em'){
        jQuery(".em-rate-area, .em-text").removeClass('hidden');
        jQuery(".loanamount").removeClass('hidden');
    }else if(apptype == 'shop'){
        jQuery(".shop-rate-area, .shop-text").removeClass('hidden');
        jQuery(".loanamount").removeClass('hidden');
    }else if(apptype == 'default'){
        jQuery(".default-text").removeClass('hidden');
    }
}

function closePaymentPop(el){
    if (jQuery('#acp-overlay').hasClass('ajaxcartpro-box-show')){
        jQuery('#acp-overlay').removeClass('ajaxcartpro-box-show').addClass('ajaxcartpro-box-hide');
    }
    jQuery(".finance-pop-overlay").addClass('hidden');
    jQuery('#'+el).toggleClass('hidden');
}